import { ChangeDetectorRef, Component, OnDestroy, ViewChild, inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { debounceTime, takeUntil } from 'rxjs/operators';
import { Filter } from 'src/app/models/common/filter';
import { AbsenceListFiltersComponent } from '../absence-list-filters/absence-list-filters.component';
import { autocompleteValidator } from 'src/app/shared/validators/autocomplete.validator';

@Component({
  selector: 'app-absences',
  templateUrl: './absences.component.html',
  styleUrls: ['./absences.component.scss'],
  standalone: false
})
export class AbsencesComponent implements OnDestroy {
  private formBuilder = inject(UntypedFormBuilder);
  private cdr = inject(ChangeDetectorRef);


  @ViewChild(AbsenceListFiltersComponent) absenceListFilters: AbsenceListFiltersComponent;

  filtersFormGroup: UntypedFormGroup;
  areFiltersExpanded: boolean = false;
  filters: Filter[] = [];

  private readonly unsubscribe$ = new Subject<void>();


  constructor() {
    this.buildFiltersFormGroup();
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.unsubscribe();
  }

  resetFilters() {
    this.filtersFormGroup.reset()
    this.absenceListFilters.setInitialSelection();
  }

  toggleFiltersPanel() {
    this.areFiltersExpanded = !this.areFiltersExpanded;
  }

  onFilterDataChange = (filters: Filter[]) => this.filters = filters;

  private buildFiltersFormGroup() {
    this.filtersFormGroup = this.formBuilder.group({
      firstName: [null],
      lastName: [null],
      companyId: [null],
      company: [null, [autocompleteValidator]],
      employer: [null],
      employerId: [null],
      employerObject: [null],
      employerObjectId: [null],
      absenceTypeId: [null],
      statusId: [null],
      startDate: [null],
      endDate: [null],
      absenceSyncStatusId: [null],
      subordinates: [null]
    });

    this.storeFiltersValueInSessionStorage();
  }

  private storeFiltersValueInSessionStorage() {
    const absencesFilters = 'absences-filters';
    const filters = JSON.parse(sessionStorage.getItem(absencesFilters));

    if (filters && Object.values(filters).some((v) => !!v)) {
      this.filtersFormGroup.patchValue(filters);
      this.areFiltersExpanded = true;
    }

    this.filtersFormGroup.valueChanges.pipe(takeUntil(this.unsubscribe$), debounceTime(1000)).subscribe(() => {
      if (this.filtersFormGroup.invalid) return;
      sessionStorage.setItem(absencesFilters, JSON.stringify(this.filtersFormGroup.getRawValue()));
    });
  }
}
